import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'rc2004',
    ecrans: ['00-2'],
    params: ['?txmcleint']
});

